var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOhiostateStackedlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232.065,
    height: 180.07,
    viewBox: "0 0 232.065 180.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ohio_state_web_mark_home_page",
    "data-name": "ohio state web mark home page",
    transform: "translate(-14.31 -12.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631",
    transform: "translate(14.31 133.388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M31.05,114.482l-.4-2.74h-5v17.69l2.665.4v1.676H18.826v-1.676l2.665-.4v-17.69h-5l-.4,2.74H14.31V109.44H32.826v5.042Z",
    transform: "translate(-14.31 -109.052)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M40.8,130.55v-1.576l2.465-.4v-6.03H36.671v6.03l2.465.4v1.576h-9v-1.576l2.565-.4V115.237l-2.565-.4V113.26h9v1.576l-2.465.4v5.2h6.593v-5.2l-2.465-.4V113.26h9v1.576l-2.565.4v13.337l2.565.4v1.576Z",
    transform: "translate(-10.335 -108.093)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M62.293,130.55H47.38v-1.576l2.565-.4V115.237l-2.565-.4V113.26H62.293v4.579H60.617l-.4-2.465H53.9v5.142h3.953l.4-2.2h1.476v6.393H58.252l-.4-2.2H53.9v5.955h6.318l.4-2.465h1.676Z",
    transform: "translate(-6.006 -108.093)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M78.046,131.987c-6.856,0-9.846-4.079-9.846-11.5,0-7.381,3.028-11.36,9.884-11.36s9.846,4.079,9.846,11.5C87.93,128,84.9,131.987,78.046,131.987Zm.038-20.455c-3.653,0-5.53,2.928-5.53,9,0,6.093,1.814,9.058,5.467,9.058s5.53-2.928,5.53-9C83.551,114.5,81.737,111.532,78.084,111.532Z",
    transform: "translate(-0.779 -109.13)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M96.037,130.55v-1.576l2.465-.4v-6.03H91.921v6.03l2.465.4v1.576h-9v-1.576l2.565-.4V115.237l-2.565-.4V113.26h9v1.576l-2.465.4v5.2H98.5v-5.2l-2.465-.4V113.26h9v1.576l-2.565.4v13.337l2.565.4v1.576Z",
    transform: "translate(3.538 -108.093)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M102.79,130.55v-1.576l2.565-.4V115.237l-2.565-.4V113.26h9.1v1.576l-2.565.4v13.337l2.565.4v1.576Z",
    transform: "translate(7.907 -108.093)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M119.53,130.936c-5.83,0-8.37-3.265-8.37-9s2.565-8.92,8.395-8.92,8.37,3.265,8.37,9S125.36,130.936,119.53,130.936Zm.038-15.639c-2.765,0-4.254,2.014-4.254,6.656,0,4.679,1.414,6.718,4.179,6.718s4.279-2.014,4.279-6.656C123.784,117.336,122.332,115.3,119.567,115.3Z",
    transform: "translate(10.008 -108.153)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M140.351,131.987a19.365,19.365,0,0,1-6.881-1.314v-4.7h1.877l.425,3.028a13.133,13.133,0,0,0,3.916.488c2.565,0,4.879-.851,4.879-3.653,0-2.54-1.777-2.9-3.953-3.628-3.453-1.151-7.119-2.139-7.119-6.881,0-3.853,2.4-6.193,7.444-6.193a19.136,19.136,0,0,1,6.593,1.251V114.8h-1.877l-.425-2.827a21.336,21.336,0,0,0-3.891-.425c-1.914,0-3.891.663-3.891,3.19,0,5.5,11.072,1.877,11.072,10.672C148.521,129.548,145.818,131.987,140.351,131.987Z",
    transform: "translate(15.61 -109.13)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M160.795,118.039l-.4-2.665h-3.816v13.212l2.565.4v1.576h-9.1v-1.576l2.565-.4V115.374H148.8l-.4,2.665H146.72V113.26h15.751v4.779Z",
    transform: "translate(18.937 -108.093)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M170.105,130.55v-1.576l2.465-.4-1.214-3.128h-6.593l-1.214,3.128,2.465.4v1.576H158.47v-1.576l2.465-.4,5.93-15.313h3.791l5.93,15.313,2.465.4v1.576Zm-2.052-13.962-2.5,6.856h5Z",
    transform: "translate(21.888 -108.093)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M188.155,118.039l-.4-2.665h-3.816v13.212l2.565.4v1.576h-9.1v-1.576l2.565-.4V115.374h-3.816l-.4,2.665H174.08V113.26h15.751v4.779Z",
    transform: "translate(25.807 -108.093)",
    fill: "#666667"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M202.8,130.55H187.87v-1.576l2.565-.4V115.237l-2.565-.4V113.26H202.8v4.579h-1.676l-.4-2.465H194.4v5.142h3.953l.4-2.2h1.476v6.393h-1.476l-.4-2.2H194.4v5.955h6.318l.4-2.465H202.8v4.554Z",
    transform: "translate(29.27 -108.093)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632",
    transform: "translate(39.895 169.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M54.865,140.254v11.485c0,3.866-.238,5.542-2.052,7.356-1.314,1.314-3.453,1.952-6.643,1.952-3.153,0-5.5-.876-6.981-2.352-1.914-1.914-1.714-4.767-1.714-7.256V140.267l-2.715-.4v-1.714h9.671v1.714l-2.715.4v13.162c0,3.691,2.052,5.167,5.2,5.167a5.182,5.182,0,0,0,3.966-1.314,5.469,5.469,0,0,0,1.239-3.866V140.254l-2.715-.4V138.14h8.17v1.714Z",
    transform: "translate(-34.76 -138.14)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M71.25,144.044v15.614H68.1L59.14,147.072v10.572l2.615.4v1.614H53.86v-1.614l2.615-.4v-13.6l-2.615-.4V142.03H60l8.6,12.023V144.044l-2.615-.4V142.03h7.882v1.614Z",
    transform: "translate(-29.964 -137.163)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M71.52,159.658v-1.614l2.615-.4v-13.6l-2.615-.4V142.03h9.271v1.614l-2.615.4v13.6l2.615.4v1.614Z",
    transform: "translate(-25.53 -137.163)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M98.3,144.044l-5.88,15.614H88.525l-5.88-15.614-2.515-.4V142.03h9.133v1.614l-2.515.4,4.466,12.086,4.429-12.086-2.515-.4V142.03h7.682v1.614Z",
    transform: "translate(-23.368 -137.163)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M112.973,159.658H97.76v-1.614l2.615-.4v-13.6l-2.615-.4V142.03h15.213V146.7h-1.714l-.4-2.515h-6.443v5.242h4.029l.4-2.252h1.514v6.518h-1.514l-.4-2.252h-4.029v6.08h6.443l.4-2.515h1.714Z",
    transform: "translate(-18.941 -137.163)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M124.816,159.658l-1.651-4.029c-1.113-2.69-1.777-3.928-4.129-3.928h-.3v5.943l2.515.4v1.614H112.08v-1.614l2.615-.4v-13.6l-2.615-.4V142.03h8.9c1.814,0,3.928.1,5.3,1.376a4.4,4.4,0,0,1,1.414,3.29,4.689,4.689,0,0,1-3.19,4.466c1.476,1.1,2.752,4.729,3.491,6.481l2.515.4v1.614h-5.692Zm-1.877-14.938c-.676-.7-2.114-.638-3.015-.638h-1.176v5.642h.7c1.138,0,2.715.138,3.553-.8a3.48,3.48,0,0,0-.063-4.2Z",
    transform: "translate(-15.345 -137.163)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M134.393,160.053a17.966,17.966,0,0,1-6.043-1.113v-4.566h1.814l.438,2.89a12.646,12.646,0,0,0,3.253.375c2.152,0,3.791-.7,3.791-2.615,0-1.339-.738-1.814-1.852-2.177-3.253-1.113-7.419-1.576-7.419-5.98,0-3.153,2.177-5.067,6.518-5.067a17.6,17.6,0,0,1,5.805,1.038V147.2h-1.814l-.438-2.752a15.8,15.8,0,0,0-3.128-.338c-1.651,0-3.09.576-3.09,2.277,0,3.928,9.3,1.314,9.3,8.295C141.549,158.1,139.059,160.053,134.393,160.053Z",
    transform: "translate(-11.26 -137.221)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M140.77,159.658v-1.614l2.615-.4v-13.6l-2.615-.4V142.03h9.271v1.614l-2.615.4v13.6l2.615.4v1.614Z",
    transform: "translate(-8.141 -137.163)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M164.048,146.9l-.4-2.715h-3.891v13.462l2.615.4v1.614H153.1v-1.614l2.615-.4V144.182h-3.891l-.4,2.715H149.71V142.03h16.052V146.9Z",
    transform: "translate(-5.897 -137.163)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M180.74,144.044,175.61,152v5.642l2.615.4v1.614h-9.271v-1.614l2.615-.4V152l-5.2-7.957-2.515-.4V142.03h9.333v1.614l-2.515.4,3.628,5.7,3.591-5.7-2.415-.4V142.03h7.794v1.614Z",
    transform: "translate(-2.346 -137.163)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M96.827,38.955l6.481-6.481h21.018l6.481,6.481V82.168l-6.481,6.481H103.308l-6.481-6.481V38.955ZM147.183,31.9,131.157,15.91H96.452L80.35,32.037V89.1l16.1,16.127h34.705l16.027-15.939V31.9Z",
    transform: "translate(16.582 0.851)",
    fill: "#ba0c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M78.909,90.889V31.624L96.349,14.2h36.469l17.515,17.428-.3,59.389-17.328,17.328H96.362L78.909,90.889ZM95.624,12.533,77.27,30.886V91.639L95.5,110.093h37.958l18.228-18.354.125-60.866L133.582,12.52H95.624Z",
    transform: "translate(15.809 0)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M101.343,32.8H118.57l4.116,4.1V76.642L118.733,80.6h-17.54l-3.891-3.9V36.857l4.041-4.054Zm23.008,3.491-5.142-5.155H100.629L95.55,36.219V77.293l4.967,4.967h18.9l4.929-4.929V36.295Z",
    transform: "translate(20.399 4.675)",
    fill: "#666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOhiostateStackedlogo);
export default __webpack_public_path__ + "static/media/ohiostate-stackedlogo.20133198bd99d537827f8b743f1160e4.svg";
export { ForwardRef as ReactComponent };